import { styled } from 'linaria/react';
import { RegularButton } from 'fronton-react';

export const StyledButton = styled(RegularButton)`
  scroll-snap-align: start;
  padding: 0 !important;
  background: var(--color-bg);
  border-radius: var(--rounding-m);
  &:last-of-type {
    margin-right: 0;
  }
  &:active {
    background-color: transparent;
    --translate-distance: 0;
  }
`;
